import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-filter',
  templateUrl: './filter.component.html'
})
export class FilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
